/** A yes/no question in a dialog ("Reset progress?"). Cancel has focus first, so Enter never destroys. */
import { useEffect, useId, useRef } from 'react';
import { Button } from './Button.tsx';
import { Dialog } from './Dialog.tsx';
import './ui.css';

export interface ConfirmDialogProps {
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel: string;
  /** Red confirm button for destructive actions. */
  danger?: boolean;
  onConfirm(): void;
  onCancel(): void;
}

export function ConfirmDialog({ title, body, confirmLabel, cancelLabel, danger = false, onConfirm, onCancel }: ConfirmDialogProps) {
  const titleId = useId();
  const bodyId = useId();
  const cancelRef = useRef<HTMLButtonElement>(null);
  useEffect(() => cancelRef.current?.focus(), []);

  return (
    <Dialog onClose={onCancel} labelledBy={titleId} describedBy={bodyId}>
      <h2 id={titleId} className="ui-dialog__title">
        {title}
      </h2>
      <p id={bodyId} className="ui-dialog__text">
        {body}
      </p>
      <div className="ui-dialog__actions">
        <Button ref={cancelRef} variant="secondary" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </div>
    </Dialog>
  );
}
